import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Breadcrumb } from 'components';
import getListing, { Listing } from 'api/ListingController/getListing';

const AccessActivityBreadcrumb = () => {
  const { listingId } = useParams<Record<string, string>>();
  const [listing, setListing] = useState<Listing>();

  useEffect(() => {
    const fetchListing = async (_listingId: string) => {
      const _listing = await getListing(_listingId);
      setListing(_listing);
    };

    if (listingId) {
      fetchListing(listingId);
    }
  }, []);

  if (!listing) return null;

  const routes = [
    {
      breadcrumbName: `${listing.line1} ${listing.line2 || ''}`,
      path: `/listing/${listing.id}/view`,
    },
    {
      breadcrumbName: 'Access Activity',
      path: '',
    },
  ];

  return <Breadcrumb routes={routes} />;
};

export default AccessActivityBreadcrumb;
